<app-public-key-upload-modal></app-public-key-upload-modal>

<ng-template [ngIf]="!isUserInfoLoading()" [ngIfElse]="userInfoLoader">
  <div class="user-settings__block user-settings__user-info">
    <div class="user-settings__user-info-groups">
      <div class="user-settings__user-info-group">
        <span class="user-settings__user-info-input-label">Business Name</span>

        <lib-text-input
          class="user-settings__user-info-input user-settings__user-info-input--read-only"
          [model]="userInfo?.businessName"
          [readOnly]="true"
          [disabled]="isUserInfoInputDisabled()"
        >
        </lib-text-input>
      </div>

      <div class="user-settings__user-info-group">
        <div class="user-settings__user-info-input-label">
          <span>Email</span>
        </div>

        <lib-text-input
          class="user-settings__user-info-input user-settings__user-info-input--with-validation"
          [model]="userInfo?.email"
          (modelChange)="onUserEmailChange($event)"
          [modelInvalid]="!!emailValidationMessage"
          [disabled]="isUserInfoInputDisabled()"
        >
        </lib-text-input>

        <span class="user-settings__input-validation-message">
          {{ emailValidationMessage }}
        </span>

        <div class="user-settings__user-info-button-group">
          <lib-button
            class="user-settings__user-info-button"
            [busy]="isSaveUserInfoButtonBusy()"
            [disabled]="isSaveUserInfoButtonDisabled()"
            (click)="onSaveUserInfoButtonClick()"
          >
            Save
          </lib-button>
        </div>
      </div>

      <ng-template [ngIf]="canShowVerifyEmail()">
        <div class="user-settings__user-info-group">
          <div class="user-settings__user-info-input-label user-settings__user-info-input-label--secondary">
            <span>Please enter the verification code that was sent to your email.</span>
          </div>

          <lib-text-input
            class="user-settings__user-info-input user-settings__user-info-input--with-validation"
            [model]="userInfo?.emailVerificationCode"
            (modelChange)="onUserEmailVerificationCodeChange($event)"
            [disabled]="isUserInfoInputDisabled()"
          >
          </lib-text-input>

          <div class="user-settings__user-info-button-group">
            <lib-button
              class="user-settings__user-info-button"
              [disabled]="isVerifyEmailButtonDisabled()"
              [busy]="isVerifyEmailButtonBusy()"
              (click)="onVerifyEmailButtonClick()"
            >
              Verify
            </lib-button>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <div class="user-settings__divider"></div>

  <div class="user-settings__block user-settings__user-access">
    <div class="user-settings__active-key">
      <span class="user-settings__active-key-text-area-label"> Active Public Key </span>

      <ng-template [ngIf]="userInfo?.sshKey" [ngIfElse]="noSHHKey">
        <lib-text-area class="user-settings__active-key-text-area" [disabled]="true" [value]="userInfo?.sshKey">
        </lib-text-area>
      </ng-template>

      <ng-template #noSHHKey>
        <span>--</span>
      </ng-template>
    </div>

    <div class="user-settings__upload-key">
      <span class="user-settings__upload-key-button-label"> Upload new Public SFTP Key </span>

      <lib-button class="user-settings__upload-key-button" (click)="onOpenButtonClick()">
        Open <i class="fa fa-upload user-settings__upload-key-button-icon"></i>
      </lib-button>
    </div>
  </div>
</ng-template>

<ng-template #userInfoLoader>
  <div class="user-settings__loader">
    <lib-loader>Loading user settings. Please wait ...</lib-loader>
  </div>
</ng-template>
